import SegmentedButton from './SegmentedButton.svelte';
export * from './SegmentedButton.types.js';
import SegmentComponent from './Segment.svelte';
export * from './Segment.types.js';
const Segment = SegmentComponent;
import { Label, Icon } from '@smui/common';
export default SegmentedButton;
export { Segment, Label, Icon };
//# sourceMappingURL=index.js.map